import { render, staticRenderFns } from "./PageSelectMenuEditFolder.vue?vue&type=template&id=641939d6"
import script from "./PageSelectMenuEditFolder.vue?vue&type=script&lang=js"
export * from "./PageSelectMenuEditFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports